// extracted by mini-css-extract-plugin
module.exports = {"pin":"styles_pin__O1WUF","bounce":"styles_bounce__ofn9p","pulse":"styles_pulse__bdFwp","pulsate":"styles_pulsate__VE84N"};